export default __webpack_public_path__ + "static/media/marryme.dcb56850.jpg";